import parsePhoneNumber from 'libphonenumber-js';

const valdiateRequired = (name) => {
  return name?.trim().length;
};

const validateName = (name) => {
  return name.trim().length > 1;
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validatePhone = (string) => {
  const phoneNumber = parsePhoneNumber(string, 'PT');
  return phoneNumber && phoneNumber.isValid();
};

const validateSubject = (subject) => {
  return subject.trim().length > 1;
};

const validateMessage = (message) => {
  return message.trim().length > 1;
};

export {
  valdiateRequired,
  validateName,
  validateEmail,
  validatePhone,
  validateSubject,
  validateMessage,
};
